import React from 'react';
import RaisedButton from 'material-ui/RaisedButton';
import ZoomIn from 'material-ui/svg-icons/action/zoom-in';
import ZoomOut from 'material-ui/svg-icons/action/zoom-out';
import classNames from 'classnames';
import round from 'utils/round';
import './ZoomControls.styl';

export default class ZoomControls extends React.PureComponent {
  constructor() {
    super(...arguments);
    this.state = {};
  }
  render() {
    return (
      <div className="zoom-controls">
        <RaisedButton className="zoom-in" onClick={this.props.onZoomIn}>
          <ZoomIn />
        </RaisedButton>
        <RaisedButton className="zoom-out" onClick={this.props.onZoomOut}>
          <ZoomOut />
        </RaisedButton>
        <div
          className={classNames('zoom-level', {
            zoomed: this.props.scale > 1,
          })}>
          {round(this.props.scale) + 'x'}
        </div>
      </div>
    );
  }
}
